import AccessAgreementPage from './AccessAgreementPage';

export default AccessAgreementPage;
